<template>
  <div id="app">
    <router-view name="Header"></router-view>
    <router-view name="Login"></router-view>
    <keep-alive>
      <router-view name="Index"></router-view>
      <router-view name="Home"></router-view>
    </keep-alive>
    <!-- 政策文件、协会公告详情 -->
    <router-view name="File"></router-view>
    <!-- 解讀详情 -->
    <router-view name="ArticleExplain"></router-view>
    <!-- 文章详情 -->
    <router-view name="Article"></router-view>
    <!-- 课程详情 -->
    <router-view name="Course"></router-view>
    <router-view name="CourseDetails"></router-view>
    <!-- 资讯 -->
    <keep-alive>
      <router-view name="Information"></router-view>
    </keep-alive>
    <router-view name="Events"></router-view>
    <!-- 杂志列表 -->
    <keep-alive>
      <router-view name="Magazine"></router-view>
    </keep-alive>
    <!-- 会员缴费 -->
    <router-view name="Fee"></router-view>
    <!-- 政策列表 -->
    <router-view name="Policy"></router-view>
    <!-- 服务列表 -->
    <keep-alive>
      <router-view name="service"></router-view>
    </keep-alive>
    <!-- 企业、协会会员列表 -->
    <keep-alive>
      <router-view name="CompanyMemberList"></router-view>
    </keep-alive>
    <!-- 企业详情 -->
    <router-view name="Company"></router-view>
    <!-- 产品详情 -->
    <router-view name="ProductDetails"></router-view>
    <!-- 协会会员详情 -->
    <router-view name="MemberDetails"></router-view>
    <!-- 搜索 -->
    <keep-alive>
      <router-view name="Search"></router-view>
    </keep-alive>
    <!-- 协会指南 -->
    <router-view name="GuideMenu"></router-view>
    <!-- 項目投資列表 -->
    <keep-alive>
      <router-view name="Invest"></router-view>
    </keep-alive>
    <!-- 訂單訊息列表 -->
    <keep-alive>
      <router-view name="Order"></router-view>
    </keep-alive>
    <!-- 訂單訊息、項目投資详情 -->
    <keep-alive>
      <router-view name="InvestInfo"></router-view>
    </keep-alive>
    <!-- 需求列表详情 -->
    <keep-alive>
      <router-view name="NeedDetails"></router-view>
    </keep-alive>
    <!-- 个人申请入会 -->
    <router-view name="ApplyPerson"></router-view>
    <router-view name="ApplyCompany"></router-view>
    <!-- 个人中心 -->
    <div :class="{ container: isPc }">
      <router-view name="UserHeader" v-if="isPc"></router-view>
      <div :class="{ main_box: isPc }">
        <router-view name="left"></router-view>
        <router-view name="userInfo"></router-view>
        <router-view name="MyCompany"></router-view>
        <keep-alive>
          <router-view name="MyMessage"></router-view>
        </keep-alive>
        <router-view name="MyMessageDetails"></router-view>
        <keep-alive>
          <router-view name="MyCollection"></router-view>
        </keep-alive>
        <keep-alive>
          <router-view name="MyNeed"></router-view>
        </keep-alive>

        <router-view name="MyRights"></router-view>
        <keep-alive>
          <router-view name="MyActivity"></router-view>
        </keep-alive>
        <keep-alive>
          <router-view name="MyQuestionnaire"></router-view>
        </keep-alive>
        <keep-alive>
          <router-view name="MyFee"></router-view>
        </keep-alive>
        <router-view name="UserAgreement"></router-view>
        <router-view name="Privacy"></router-view>
        <!-- 协会介绍 -->
        <router-view name="IntroduceNav"></router-view>
        <keep-alive>
          <router-view name="Introduce"></router-view>
        </keep-alive>
        <router-view name="InfoDetails"></router-view>
      </div>
    </div>
    <router-view name="Footer"></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "app",
  components: {},
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    this.$store.dispatch("checkToken");
    this.$store.dispatch("checkWindowWidth");
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: auto;

  .main_box {
    display: flex;
    // margin-top: 10px;
  }
}
</style>
